import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { Button, ButtonType, Container, Dialog, ScanField, ScanIcon } from '../../'
import { appStore } from '../../../index'
import { Pages } from '../../../Stores/AppStore'
import classes from './ScanJob.module.css'
import { LNG } from '../../../Services/LanguageService';

export const ScanJob = observer(() => {
  const _onCancelClick = () => {
    appStore.setPage(Pages.Home)
  }

  const _onStartClick = () => {
    appStore.setPage(Pages.ScanPositions)
  }
  const jobCls = [classes.job]
  if (!appStore.appState.job) {
    jobCls.push(classes.invisible)
  }

  const _actions = (
    <>
      <Button label={LNG.Text('scannerApp.21')} onClick={_onCancelClick}/>
      {appStore.appState.job && <Button type={ButtonType.Primary} label={LNG.Text('scannerApp.11')} onClick={_onStartClick}/>}
    </>
  )

  const _dialogActions = [
    {
      label: LNG.Text('scannerApp.12'),
      onClick: appStore.clearConfirmation,
    },
  ]

  return (
    <Container actions={_actions} showLoader={appStore.dataLoader.isPending}>
      {!appStore.appState.job && <ScanField onChange={appStore.getJobCard}/>}
      <ScanIcon label={LNG.Text(!appStore.appState.job ? 'scannerApp.13' : 'scannerApp.14')} iconHidden={!!appStore.appState.job}/>
      <div className={jobCls.join(' ')}>
        <div className={classes.info}>{LNG.Text('scannerApp.15')}: <b>{appStore.appState.job?.rid}</b></div>
        <div className={classes.info}>{LNG.Text('scannerApp.16')}: <b>{appStore.appState.job?.orderNumber}</b></div>
      </div>
      {appStore.confirmationMessage && <Dialog title={appStore.confirmationMessage} actions={_dialogActions}/>}
    </Container>
  )
})

